<div class="flex flex-col gap-2">
  <guarantees-partner-picker
    [service]="service()"
    [selected]="partner()"
    (chosen)="choosePartner($event)"
  ></guarantees-partner-picker>

  <!-- Only under a partner: a doctor is named within one, never across all of them. -->
  @if (partner(); as chosenPartner) {
    <guarantees-search-field
      cdkOverlayOrigin
      #doctorOrigin="cdkOverlayOrigin"
      icon="stethoscope"
      name="restrictionDoctor"
      [ariaLabel]="'guaranteeV2.label.doctor' | translate"
      [placeholder]="doctorDisplay() || ('guaranteeV2.message.searchDoctorByName' | translate)"
      [filled]="!!doctorDisplay()"
      [value]="doctorTerm()"
      [loading]="loadingDoctors()"
      (valueChange)="typeDoctor($event)"
      (opened)="openDoctors()"
      (closed)="closeDoctors()"
    ></guarantees-search-field>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="doctorOrigin"
      [cdkConnectedOverlayOpen]="doctorsOpen()"
      [cdkConnectedOverlayWidth]="panelWidth()"
      [cdkConnectedOverlayPositions]="overlayPositions"
      (overlayOutsideClick)="closeDoctors()"
    >
      <guarantees-option-list
        [empty]="doctors().length === 0 && !loadingDoctors()"
        [emptyMessage]="'guaranteeV2.message.noDoctorsInDirectory' | translate"
      >
        @for (option of doctors(); track option.id) {
          <li>
            <button
              guaranteesOption
              type="button"
              [class]="option.id === doctor()?.id ? 'bg-primary-50' : ''"
              (click)="chooseDoctor(option)"
            >
              <span class="min-w-0 flex-1 truncate text-neutral-700">{{ option.fullName }}</span>
            </button>
          </li>
        }
      </guarantees-option-list>
    </ng-template>

    <!-- What it comes to, and the ways back out of it. -->
    <div class="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-neutral-500">
      <mat-icon class="h-3.5! w-3.5! shrink-0 text-sm! leading-3.5! text-primary-600">place</mat-icon>
      <span class="min-w-0 flex-1 truncate">{{ chosenPartner.name }}{{ doctorDisplay() ? " · " + doctorDisplay() : "" }}</span>

      @if (doctor()) {
        <button
          class="shrink-0 rounded-full border border-neutral-200 px-2 py-0.5 text-sm font-medium text-neutral-500 hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none"
          type="button"
          (click)="clearDoctor()"
        >
          {{ "guaranteeV2.action.clearRestrictionDoctor" | translate }}
        </button>
      }

      <button
        class="shrink-0 rounded-full border border-neutral-200 px-2 py-0.5 text-sm font-medium text-neutral-500 hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none"
        type="button"
        (click)="clear()"
      >
        {{ "guaranteeV2.action.clearRestriction" | translate }}
      </button>
    </div>
  }
</div>
